export default function FinishScreen({
  points,
  dispatch,
  setRestart,
  effectRan,
}) {
  return (
    <div className="">
      <p className="result">
        You scored <strong>{points}</strong> out of 10 Points
      </p>
      <button
        className="btn btn-ui"
        onClick={() => {
          effectRan.current = !effectRan.current;
          setRestart((prev) => !prev);
          dispatch({ type: "restart" });
        }}
      >
        Restart Quiz
      </button>
    </div>
  );
}
